export default __webpack_public_path__ + "static/media/publicity1.67d0e5ef.jpeg";